export function formatTime(t) {
  let n = new Date(t);
  n = n.getFullYear() + '年' + (n.getMonth() + 1) + '月' + n.getDate() +'日' + n.getHours() + '时' + n.getMinutes() + '分';
  return n;
}

// 获取日期差（剩余天数时间）
export function diffDate(endDate) {
  var date = new Date(endDate)
  var endDate = date.getTime();
  var nowDate = new Date().getTime();
  var dateDiff = endDate - nowDate;
  var dayDiff = Math.floor(dateDiff / (24*3600*1000)); // 天数
  var second = dateDiff % (24*3600*1000); // 计算天数后剩余的毫秒数
  var hours = Math.floor(second/(3600*1000)); // 计算出小时数
  // 计算相差分钟数
  var second2 = second % (3600*1000); // 计算小时后剩余的毫秒数
  var minutes = Math.floor(second2 / (60*1000)); // 计算相差分钟数
  // 计算相差秒数
  var second3 = second2 % (60*1000); // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(second3 / 1000)
  // return "剩余"+dayDiff+"天 "+hours+"小时 "+minutes+"分钟 "+seconds+"秒"
  return "剩余"+dayDiff+"天"+hours+"小时"+minutes+"分钟";
}